import React, { useState } from 'react';
import PropTypes from 'prop-types';
import JsonView from '@uiw/react-json-view';

import { fetchData } from '../../helpers/methods';

import AiButtonClose from '../buttons/ai-button-close';
import AiButtonDebug from '../buttons/ai-button-debug';
import AiLoadingBar from '../loading/ai-loading-bar';
import AiOopsMessage from '../general/ai-oops-message';

const AiDebug = ({
	feedbackKey,
}) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [data, setData] = useState({});

	const aiJsonTheme = {
		fontSize: '14px',
		'--w-rjv-font-family': 'monospace',
		'--w-rjv-background-color': '#202020',
		'--w-rjv-color': '#e8e8e8',
		'--w-rjv-key-string': '#e8e8e8',
		'--w-rjv-quotes': '#e8e8e8',
		'--w-rjv-quotes-color': '#e8e8e8',
		'--w-rjv-quotes-string-color': '#cb4fc8',
		'--w-rjv-type-string-color': '#cb4fc8',
		'--w-rjv-ellipsis': '#cb4fc8',
		'--w-rjv-ellipsis-color': '#cb4fc8',
		'--w-rjv-object-key': '#00ffe4',
		'--w-rjv-object-key-color': '#00ffe4',
		'--w-rjv-key-number-color': '#00ffe4',
		'--w-rjv-key-number': '#00ffe4',
		'--w-rjv-arrow-color': '#00ffe4',
		'--w-rjv-type-int-color': '#2e71da',
		'--w-rjv-type-float-color': '#2e71da',
		'--w-rjv-type-boolean-color': '#8bc34a',
		'--w-rjv-type-null-color': '#757575',
		'--w-rjv-curlybraces-color': '#E8E8E8',
		'--w-rjv-brackets-color': '#E8E8E8',
		'--w-rjv-colon-color': '#a5a5a5',
		'--w-rjv-line-color': '#383838',
		'--w-rjv-object-size': '#a5a5a5',
		'--w-rjv-info-color': '#a5a5a5',
	};

	const handleModalContainerClick = e => {
		e.stopPropagation();
	};

	const getData = () => {
		setLoading(true);
		setIsOpen(true);
		const uri = `/api/web/feedbacks/${feedbackKey}`;
		fetchData({
			uri,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					let newPayload = {};
					if (body?.payload?.length > 0) {
						newPayload = JSON.parse(body.payload);
					}
					setData(newPayload);
					setLoading(false);
				} else {
					setLoading(false);
					setError(true);
				}
			})
			.catch(() => {
				setLoading(false);
				setError(true);
			});
	};

	return (
		<div className="ignite-ai__rating-container align-self-center">
			<AiButtonDebug
				action={() => getData()}
			/>
			{isOpen && (
				<div className={`ignite-ai__modal-background-debug ${!isOpen && 'd-none'}`} role="presentation" onClick={() => setIsOpen(false)}>
					<div
						className={`ignite-ai__modal-debug ${isOpen && 'is-open'}`}
						role="presentation"
						onClick={handleModalContainerClick}
					>
						<div className="ignite-ai__debug-modal-title-container justify-flex-end">
							<AiButtonClose
								action={() => setIsOpen(false)}
							/>
						</div>
						<div className="ignite-ai__modal-child-container">
							{loading && (
								<AiLoadingBar />
							)}
							{(!loading && !error) && (
								<pre className="ignite-ai__debug-json">
									<JsonView
										value={data}
										style={aiJsonTheme}
										displayDataTypes={false}
										shortenTextAfterLength={500}
										collapsed={1}
									/>
								</pre>
							)}
							{error && (
								<AiOopsMessage
									centered
								/>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default AiDebug;

AiDebug.propTypes = {
	feedbackKey: PropTypes.string.isRequired,
};
